export default __webpack_public_path__ + "static/media/case_2.7ac9b97c.png";